import { useTranslation } from 'react-i18next';
import { PowerOff } from 'lucide-react';

/**
 * "PC turned off" under a closed sitting's end (owner, 2026-10-14: "whenever
 * a PC is turned off it should stop their session immediately").
 *
 * A sitting the venue system stopped because its PC went away — Windows shut
 * down at the machine, or the PC fell silent for ten minutes — ends with
 * `endedReason: 'POWERED_OFF'`, billed up to the moment it went off rather
 * than to whenever somebody noticed. Staff meet those sittings later, at the
 * counter or in Bills, with nobody around who remembers the PC going dark;
 * without the note the shorter-than-expected time reads as a mistake.
 *
 * One component for every place that shows a sitting's end, so the words and
 * the marker (`data-powered-off`) are the same on all of them. A block, so it
 * sits on its own line under the time and follows the cell's alignment.
 * Renders nothing for any other ending.
 */
export function PoweredOffNote({ endedReason }: { endedReason: 'POWERED_OFF' | null | undefined }) {
  const { t } = useTranslation();
  if (endedReason !== 'POWERED_OFF') return null;

  return (
    <span
      data-powered-off
      title={t('sessions.poweredOffHint')}
      className="block text-xs font-normal text-content-muted"
    >
      <PowerOff className="me-1 inline h-3 w-3 align-[-2px]" aria-hidden />
      {t('sessions.poweredOff')}
    </span>
  );
}
